module.exports = __webpack_public_path__ + "img/hero-blur-shape.ca945f83.png";